import { api } from './api.js';

export async function listSavedQueries() {
  const r = await api.get('/api/saved-queries');
  return r.queries || [];
}

export async function createSavedQuery(q) {
  return api.post('/api/saved-queries', q);
}

export async function updateSavedQuery(id, q) {
  return api.patch(`/api/saved-queries/${id}`, q);
}

export async function deleteSavedQuery(id) {
  return api.delete(`/api/saved-queries/${id}`);
}
